import { createContext, useContext } from 'react';
import type { AllianceRole, AllianceSummary, Planet } from '@kaeliux/shared';

/** The loaded Team planet plus who is looking at it, provided by `TeamPlanetLayout` to every `/team-planet/*` page. */
export interface TeamPlanetSession {
    teamPlanet: Planet;
    alliance: AllianceSummary;
    viewerRole: AllianceRole | null;
    /** `manageTeamPlanet`: leader and officers queue/cancel buildings and research. */
    canManage: boolean;
    /** Only the leader dispatches fleets and cancels any member's ship batch. */
    isLeader: boolean;
}

export const TeamPlanetContext = createContext<TeamPlanetSession | null>(null);

export function useTeamPlanetSession(): TeamPlanetSession {
    const session = useContext(TeamPlanetContext);
    if (!session) throw new Error('useTeamPlanetSession must be used inside TeamPlanetLayout');
    return session;
}
